import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { SharedService } from 'src/app/core/Services/shared.service';
import { Survey } from '../../Models/Survey';
import { SurveyService } from '../../Services/survey.service';
import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';

@Component({
    selector: 'survey-list',
    templateUrl: './survey-list.component.html',
    styleUrls: ['./survey-list.component.scss']
})

export class SurveyListComponent implements OnInit, OnDestroy {

    SurveyList: MatTableDataSource<Survey>;
    columns: string[] = ['SurveyName', 'PublishedDate', 'StartDate', 'EndDate', 'options'];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sorting: MatSort;

    constructor(private _shared: SharedService, private _survey: SurveyService) {
        // Setting up page title
        this._shared.pageTitle = 'Survey List';

        // Show loader
        this._shared.loadingState = true;

        // Display and subscribe to search
        this._shared.displaySearchBox.next(true);
        this._shared.searchString.subscribe(res => {
            if (this.SurveyList) { this.SurveyList.filter = res; }
        });
    }

    async ngOnInit() {
        this.SurveyList = new MatTableDataSource<Survey>(await this._survey.getSurveyList());
        setTimeout(() => {
            this.SurveyList.paginator = this.paginator;
            this.SurveyList.sort = this.sorting;
            this._shared.loadingState = false;
        })
    }

    ngOnDestroy() {
        // Hide search box
        this._shared.displaySearchBox.next(false);
    }
}